<template>
    <div class="box-requested-dt box-sec">
        <div class="box-request-info">
            <div class="wrap-noted-rq flexbox justify-content-flex-end-last-left">
                <div :class="'notice-rq ' + request_class">{{ request_status_msg }}</div><div v-if="my_request" class="my-request">自分の要望</div>
                <div v-if="(request_apply_developer_id===account_id && (account_id))" class="my-request">あなたに発注依頼</div>
                <div class="requested-date">登録日 {{ request_datetime }}</div>
            </div>
            <div class="requested-title">
                <p class="title">{{ request_title }}</p>
            </div>
            <div class="flexbox wrap-request-all">
                <div class="flexbox wrap-request-info">
                    <div class="wrap-service-like flexbox justify-content-between">
                        <div class="list-icon-service flexbox">
                            <div class="icon-service" v-for="service in request_service">
                                <img :src="'/images/' + list_img_service[service]">
                            </div>
                        </div>
                    </div>
                    <div class="list-cate-requested">
                        <span class="box-cate-rqt" v-for="category in request_category">{{ category_list[category] }}</span>
                    </div>
                </div>
            </div>
            <like-component :requestId="request_id" :account_id="account_id" :isCheckLiked="current_user_liked" :countLike="count_like" :isDisabledLiked="is_disabled_liked"></like-component>
        </div>
        <form :action="request_route" method="GET" id="copy_request">
            <input type="hidden" name="request_id" :value="request_id" />
            <ul class="list-rq-info-dt">
                <li class="item-rq-info-dt flexbox">
                    <div class="col-left">
                        <span class="lbl-name">要望詳細</span>
                    </div>
                    <div class="col-right">
                        <div class="info-rq">{{ request_detail }}</div>
                    </div>
                </li>
                <li class="item-rq-info-dt flexbox">
                    <div class="col-left">
                        <span class="lbl-name">応募条件</span>
                    </div>
                    <div class="col-right">
                        <div class="info-rq">{{ app_condition }}</div>
                    </div>
                </li>
                <li class="item-rq-info-dt flexbox">
                    <div class="col-left">
                        <span class="lbl-name">添付ファイル</span>
                    </div>
                    <div class="col-right">
                        <div class="info-rq">
                            <a v-if="attachment_file" :href="attachment_path" target="_blank">{{ attachment_file_name }}</a>
                            <span v-else class="null">指定なし</span>
                        </div>
                    </div>
                </li>
                <li class="item-rq-info-dt flexbox">
                    <div class="col-left">
                        <span class="lbl-name">備考</span>
                    </div>
                    <div class="col-right">
                        <div class="info-rq">{{ request_remarks}}</div>
                    </div>
                </li>
                <li class="item-rq-info-dt flexbox">
                    <div class="col-left">
                        <span class="lbl-name">納期</span>
                    </div>
                    <div class="col-right">
                        <div class="info-rq">{{ delivery_date }}</div>
                    </div>
                </li>
                <li class="item-rq-info-dt flexbox">
                    <div class="col-left">
                        <span class="lbl-name">予算</span>
                    </div>
                    <div class="col-right">
                        <div class="info-rq">{{ request_budget }}</div>
                    </div>
                </li>
                <request-action-component v-if="is_disabled_action===false" :request_status_list="request_status_list" :requestId="request_id" :account_id="account_id" :my_request="my_request" :request_status="request_status" :request_edit_link="request_edit_link" :request_delete_link="request_delete_link"></request-action-component>
                <form :action="request_copy_link" method="GET" :id="'copy_request_' + request_id" class="m-0">
                    <input type="hidden" name="request_id" id="copy_request_id" :value="request_id" />
                </form>
            </ul>
        </form>
    </div>
</template>

<script>
    import LikeComponent from '../components/LikeComponent';
    import RequestActionComponent from '../components/RequestActionComponent';

    export default {
        name: 'request-detail-component',
        props: {
            request_id: Number,
            account_id: String,
            is_disabled_liked: Boolean,
            is_disabled_action: Boolean,
            current_user_liked: Boolean,
            list_img_service: Object,
            request_class: String,
            request_status_msg: String,
            request_title: String,
            request_datetime: String,
            request_service: Array,
            request_category: Array,
            category_list: Object,
            request_detail: String,
            app_condition: String,
            attachment_path: String,
            attachment_file: String,
            attachment_file_name: String,
            request_remarks: String,
            delivery_date: String,
            request_budget: String,
            request_status_list: Object,
            request_copy_link: String,
            request_delete_link: String,
            request_route: String,
            count_like: String,
            request_status: String,
            request_edit_link: String,
            my_request: Boolean,
            request_apply_developer_id: String,
        },
        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },

        components: {
            LikeComponent, RequestActionComponent
        }
    }

</script>
